import { IQuestion } from 'cat-shared/utils'
import { AppDivider, AppHeader } from 'client/ui-building-blocks'
import { UserAvatar } from 'client/components'
import { type TGetQuestionsData } from 'client/api/useGetQuestions/useGetQuestions'

import {
  QuestionMetaChips,
  QuestionMetaText,
  QuestionMetaBtns,
} from 'client/components/Question'

import styles from './question-meta.module.scss'

type Props = {
  question: IQuestion
  questionsData?: TGetQuestionsData
  areResultsBeingLoaded?: boolean
}

export const QuestionMeta = ({
  question,
  questionsData,
  areResultsBeingLoaded = false,
}: Props) => {
  return (
    <div className={styles.questionMeta}>
      <div className={styles.flex}>
        <div>
          <QuestionMetaChips question={question} />
          {question && question._id ? (
            <>
              <AppDivider size="xxsmall" />
              <QuestionMetaText question={question} questionsData={questionsData} />
            </>
          ) : null}
        </div>
        <div>
          <UserAvatar userId={question?.creatorId?.toString()} profileLink="NEW_TAB" />
        </div>
      </div>
      <AppDivider size="small" />
      <AppHeader text={question.text} size="large" />
      <AppDivider size="xsmall" />
      <QuestionMetaBtns question={question} disabled={areResultsBeingLoaded} />
    </div>
  )
}
